<template>
  <div v-if="message"
       class="w-full bg-red-500 border-l-4 rounded-sm border-red-700 p-1 mt-1 mb-1">
    {{ message }}
  </div>
</template>

<script>
export default {
  props: {
    message: String
  },
};
</script>